import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { LocationsApi } from '../../../../api/locations.api';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LocationLegacyComponent; }),
    multi: true
};
var LocationLegacyComponent = /** @class */ (function () {
    function LocationLegacyComponent(fuseTranslationLoaderService, locationsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.locationsApi = locationsApi;
        this.locations = new Array();
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    LocationLegacyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.inputValue.valueChanges
            .pipe(filter(function (searchTerm) {
            return !!searchTerm;
        }), debounceTime(500), switchMap(function (searchTerm) {
            _this.loading = true;
            _this.locations = [];
            return _this.locationsApi.search({ formattedAddressOrDocumentNumber_contains: searchTerm, archived: false }, {
                orderLegacy: false,
                orderColumn: 'formattedAddress',
                order: 'asc',
                offset: 0,
                operator: 'distance',
                value: searchTerm,
                limit: 10
            });
        }))
            .subscribe(function (result) {
            _this.loading = false;
            _this.locations = result.items;
        });
    };
    LocationLegacyComponent.prototype.writeValue = function (locationId) {
        var _this = this;
        if (locationId) {
            this.locationsApi.searchOne(locationId).toPromise().then(function (location) {
                _this.selectedLocation = location;
                _this.hasSelectedLocation = true;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.deselectLocation();
        }
    };
    LocationLegacyComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    LocationLegacyComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    LocationLegacyComponent.prototype.setSelectedLocation = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.onChange(this.inputValue.value);
            this.selectedLocation = this.locations.find(function (location) { return location.id === _this.inputValue.value; });
            this.hasSelectedLocation = true;
            this.inputValue.setErrors(null);
        }
    };
    LocationLegacyComponent.prototype.deselectLocation = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedLocation = null;
        this.hasSelectedLocation = false;
        this.inputValue.setErrors(null);
    };
    return LocationLegacyComponent;
}());
export { LocationLegacyComponent };
